(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.roomInput
   */
  angular
    .module("akitabox.mobile.directives.roomInput", [
      "akitabox.core.services.roomsBff",
      "akitabox.core.services.organization",
    ])
    .directive("abmRoomInput", AbmRoomInputDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.roomInput
   * @name AbmRoomInputDirective
   * @restrict E
   * @description
   * `abm-room-input` creates a dropdown menu to allow for selection of the floors
   */

  /* @ngInject */
  function AbmRoomInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/room-input/room-input.html",
      controller: AbmRoomInputController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        placeholder: "@?",
        ngModel: "=",
        ngChange: "&?",
        floor: "=",
        building: "=",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      vm.required = angular.isDefined(attrs.required);
      $scope.$watch("vm.building", function (newValue, oldValue) {
        resetNgModel(newValue, oldValue, "building");
        vm.placeholder = updatePlaceholder();
      });

      $scope.$watch("vm.floor", function (newValue, oldValue) {
        resetNgModel(newValue, oldValue, "level");
        vm.placeholder = updatePlaceholder();
      });

      /**
       * Determines if ngModel should be set to null
       *
       * @param newValue
       * @param oldValue
       * @param type
       */
      function resetNgModel(newValue, oldValue) {
        if (!vm.ngModel) return; // We only want to reset ngModel if there is an ngModel

        // Determine if the newValue and the oldValue has actually changed
        // Since this is a room, it would see if the building or level has actually changed
        // so value in this sense would usually be a building or level
        var hasChanged = (newValue && !oldValue) || (!newValue && oldValue);

        if (
          newValue &&
          oldValue &&
          Object.prototype.hasOwnProperty.call(newValue, "_id") &&
          Object.prototype.hasOwnProperty.call(oldValue, "_id")
        ) {
          hasChanged = hasChanged || newValue._id !== oldValue._id;
        } else {
          hasChanged = hasChanged || newValue !== oldValue;
        }

        // Only reset the model if the dependency has changed
        if (hasChanged) {
          vm.ngModel = null;
        }
      }

      /**
       * Updates the placeholder text to show a enabled and disabled mode
       *
       * @returns {*}
       */
      function updatePlaceholder() {
        if (!vm.building) {
          return "Building required";
        } else if (!vm.floor) {
          return "Floor required";
        }

        return vm.originalPlaceholder;
      }
    }
  }

  /* @ngInject */
  function AbmRoomInputController(
    // Angular
    $log,
    $q,
    // Services
    ToastService,
    RoomsBFFService,
    OrganizationService
  ) {
    var self = this;

    var allRooms = null;
    var roomRequest = null;
    var lastFloorId = self.floor ? self.floor._id : null;
    self.organization = OrganizationService.getCurrent();

    if (angular.isUndefined(self.ngModel)) {
      return $log.error("<abm-room-input> ng-model is unassigned");
    } else if (angular.isUndefined(self.floor)) {
      return $log.error("<abm-room-input> floor is unassigned");
    } else if (angular.isUndefined(self.building)) {
      return $log.error("<abm-room-input> building is unassigned");
    }

    self.isDisabled = isDisabled;
    self.querySearch = querySearch;
    self.onChange = onChange;

    self.loading = false;
    self.searchText = null;
    self.placeholder = self.placeholder || "Choose a room";
    self.originalPlaceholder = self.placeholder;

    function isDisabled() {
      return !self.ngModel && (!self.building || !self.floor);
    }

    function querySearch(searchText) {
      if (!self.building || !self.floor) {
        return $q.resolve([]);
      }

      self.searchText = searchText;

      // Use initial request/data if the parameters haven't changed
      if (!hasFloorChanged()) {
        if (allRooms) {
          // Filter and return on all rooms if we've already fetched them
          return filterQuery(self.searchText, allRooms);
        }

        // Use the outstanding request, if we have one
        if (self.loading) {
          return roomRequest;
        }
      }

      var floorId = self.floor && self.floor._id ? self.floor._id : self.floor;

      var data = {
        level: floorId,
      };

      // Update previous floor
      lastFloorId = floorId;

      self.loading = true;
      roomRequest = RoomsBFFService.getAllTypeAheads(
        self.organization._id,
        data
      )
        .then(function (rooms) {
          allRooms = rooms;
          return filterQuery(self.searchText, allRooms);
        })
        .catch(function (err) {
          ToastService.showError(err);
          return [];
        })
        .finally(function () {
          self.loading = false;
        });

      return roomRequest;
    }

    function filterQuery(searchText, matches) {
      if (angular.isEmpty(searchText)) {
        return angular.copy(allRooms);
      }

      var regex = new RegExp(searchText, "i");
      return matches.filter(function (match) {
        return match.name.match(regex) || match.number.match(regex);
      });
    }

    /**
     * Determine if the floor has changed since the last request for rooms was
     * made
     *
     * @return {Boolean}   True if changed, false if not
     */
    function hasFloorChanged() {
      return self.floor ? lastFloorId !== self.floor._id : lastFloorId;
    }

    function onChange(item) {
      if (angular.isFunction(self.ngChange)) {
        self.ngChange({ value: item });
      }
    }
  }
})();
